// extracted by mini-css-extract-plugin
export default {"cookies":"cookies_cookies__ncyKl","cookies__wrapper":"cookies_cookies__wrapper__l9HL-"};